import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import { GetUserLogin, GetOrderDetails } from "../../../../../services";

import { NotificationManager } from "react-notifications";

import Moment from "react-moment";

import "../../css/index.css";

import "./order.css";



class List extends Component {

  constructor(props) {

    super(props);

    this.state = {

      customer: "",

      user: "",

      orderList: [],

      searchQuery: "",

      currentPage: 1,

      itemsPerPage: 10, // Set the number of items per page

      visiblePages: 8, // Number of page numbers to show at a time

      pageGroupStart: 1, // Track the starting page number of the visible group

      isMobile: window.innerWidth <= 768, // Detect mobile screen width

    };

  }



  async componentDidMount() {

    let email = sessionStorage.getItem("email");

    if (email) {

      let value = await GetUserLogin.getCustomerDetail(email);

      if (value && value.data) {

        this.setState({ customer: value.data, user: value.data }, async () => {

          let list = await GetOrderDetails.getOrderByUser(

            this.state.customer.phone

          );

          this.setState({

            orderList: list.orders,

            currentPage: 1,

            pageGroupStart: 1,

          });

        });

      } else {

        NotificationManager.error("Check your credentials", "Login");

      }

    }

  }



  refreshOrders = async () => {

    try {

      NotificationManager.info("Refreshing your orders...", "Please wait");



      // Call backend refresh API

      const refreshResult = await GetOrderDetails.getOrderRefreshByUser(

        this.state.customer.id

      );



      if (refreshResult) {

        // Show backend message

        if (refreshResult.message) {

          NotificationManager.info(refreshResult.message);

        }

      }



      // Now fetch updated orders

      let list = await GetOrderDetails.getOrderByUser(

        this.state.customer.phone

      );



      this.setState({

        orderList: list.orders,

        currentPage: 1,

        pageGroupStart: 1,

      });



      NotificationManager.success("Orders refreshed successfully!", "Updated");

    } catch (error) {

      NotificationManager.error("Failed to refresh orders", "Error");

    }

  };


  handleLogout = async (event) => {

    event.preventDefault();

    await GetUserLogin.logout();

  };



  handleSearch = (event) => {

    this.setState({ searchQuery: event.target.value });

  };



  // Fetch the selected ZIP without creating a download link or triggering a download.
  // Supports services that return a Blob, ArrayBuffer, or an Axios response.
 
  // Retrieve the ZIP file from the existing API.
  getZipResult = async (variantPath) => {
    if (!variantPath) {
      throw new Error("Variant file path is missing.");
    }

    const originalFilename = String(variantPath).split("/").pop();

    const keywordsToRemove = [
      "DSTBERNINA14x8",
      "DSTFULL",
      "JEFUSHA45011x8",
      "JEFUSHA55014x8",
      "PESBROTHERBP360014x9.5",
    ];

    const baseName = originalFilename.replace(/\.zip$/i, "");

    const candidates = [
      originalFilename,
      `${baseName}.zip`,
      `${baseName.replace(/DSTBROTHERV3SE/, "DSTBROTHERV3V3SE")}.zip`,
      `${baseName.replace(/DSTBROTHERV3V3SE/, "DSTBROTHERV3SE")}.zip`,
      `${baseName.replace(/12x8$/, "").trim()}.zip`,
      `${baseName.replace(/DSTBROTHERV3SE/, "DSTBROTHERV3V3SE")
        .replace(/12x8$/, "").trim()}.zip`,
      `${baseName.replace(/DSTBROTHERV3V3SE/, "DSTBROTHERV3SE")
        .replace(/12x8$/, "").trim()}.zip`,
      keywordsToRemove.reduce(
        (name, keyword) => name.replaceAll(keyword, "").trim(),
        originalFilename
      ),
    ];

    let response = null;
    let lastError = null;

    for (const filename of [...new Set(candidates)]) {
      try {
        const result = await GetOrderDetails.getOrderDownload(filename);

        if (result == null) continue;

        // Support Axios responses and APIs that return data directly.
        let payload =
          result.data !== undefined ? result.data : result;

        // Unwrap an additional data property if the API uses one.
        if (
          payload &&
          !(payload instanceof Blob) &&
          !(payload instanceof ArrayBuffer) &&
          !ArrayBuffer.isView(payload) &&
          typeof payload === "object" &&
          payload.data !== undefined
        ) {
          payload = payload.data;
        }

        // Some APIs return a downloadable URL instead of file bytes.
        if (
          typeof payload === "string" &&
          /^https?:\/\//i.test(payload)
        ) {
          const fileResponse = await fetch(payload);

          if (!fileResponse.ok) {
            throw new Error(`File request failed: ${fileResponse.status}`);
          }

          payload = await fileResponse.blob();
        }

        // A JSON response usually means an API error, not a ZIP.
        if (
          payload instanceof Blob &&
          payload.type.includes("application/json")
        ) {
          const errorText = await payload.text();
          throw new Error(errorText || "The server returned an API error.");
        }

        if (payload instanceof ArrayBuffer ||
            ArrayBuffer.isView(payload)) {
          payload = new Blob([payload], {
            type: "application/zip",
          });
        }

        if (
          !(payload instanceof Blob) &&
          typeof payload === "string" &&
          payload.length > 0
        ) {
          // Avoid silently downloading a JSON/error string as a ZIP.
          try {
            const parsed = JSON.parse(payload);
            if (parsed && typeof parsed === "object") {
              throw new Error(
                parsed.message || "The server did not return a ZIP file."
              );
            }
          } catch (error) {
            if (error instanceof SyntaxError) {
              // A non-JSON string may represent binary data converted
              // incorrectly by the API service. Do not assume it is a ZIP.
              throw new Error(
                "The API returned text instead of ZIP file data. Check responseType: blob."
              );
            }
            throw error;
          }
        }

        if (payload instanceof Blob && payload.size > 0) {
          response = {
            blob: payload,
            filename: filename.toLowerCase().endsWith(".zip")
              ? filename
              : `${filename}.zip`,
          };
          break;
        }
      } catch (error) {
        lastError = error;
        console.error(`Failed to retrieve ${filename}:`, error);
      }
    }

    if (!response) {
      throw lastError || new Error("ZIP file not found.");
    }

    return response;
  };

  // Download button: fetch the ZIP and save it to the user's device.
 
handleDownload = async (variantPath) => {
  if (!variantPath) {
    NotificationManager.error(
      "Variant file path is missing.",
      "Download Failed",
      4000
    );
    return;
  }

  // Show progress immediately.
  NotificationManager.info(
    "Preparing your ZIP file. Please wait...",
    "Downloading",
    3000
  );

  try {
    // Fetch the ZIP from the existing API.
    const result = await this.getZipResult(variantPath);

    if (!result?.blob || result.blob.size === 0) {
      throw new Error("The ZIP file is empty or unavailable.");
    }

    // Start the browser download.
    const objectUrl = window.URL.createObjectURL(result.blob);
    const anchor = document.createElement("a");

    anchor.href = objectUrl;
    anchor.download = result.filename;
    anchor.style.display = "none";

    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();

    // Allow the browser to start processing the download.
    window.setTimeout(() => {
      window.URL.revokeObjectURL(objectUrl);
    }, 1500);

    // Notify the user that the download was initiated.
    NotificationManager.success(
      `${result.filename} is being saved to your Downloads folder.`,
      "Download Started",
      4000
    );
  } catch (error) {
    console.error("ZIP download failed:", error);

    NotificationManager.error(
      error.message || "Unable to download this ZIP file.",
      "Download Failed",
      4000
    );
  }
};


  // JC Nexus: load the ZIP into memory without downloading it to disk.
  handleJCCanvas = async (variant) => {
    if (!variant?.variantPath) {
      NotificationManager.error(
        "Variant file path is missing.",
        "JC Nexus"
      );
      return;
    }

    try {
      const result = await this.getZipResult(variant.variantPath);

      this.props.history.push({
        pathname: "/embroidery/nexus",
        state: {
          zipBlob: result.blob,
          zipFilename: result.filename,
          variantPath: variant.variantPath,
          variantName: variant.variantName || "",
        },
      });
    } catch (error) {
      console.error("JC Nexus ZIP retrieval failed:", error);
      NotificationManager.error(
        error.message || "Could not load the variant ZIP.",
        "JC Nexus",
        4000
      );
    }
  };



  componentWillUnmount() {

    // Remove event listener for window resize when the component unmounts

    window.removeEventListener("resize", this.updateIsMobile);

  }



  updateIsMobile = () => {

    this.setState({ isMobile: window.innerWidth <= 768 });

  };



  // Pagination Methods

  handlePageChange = (pageNumber) => {

    this.setState({ currentPage: pageNumber });

  };



  // Handle next page group

  handleNextPageGroup = () => {

    const { pageGroupStart, visiblePages, orderList, itemsPerPage } =

      this.state;

    const totalPages = Math.ceil(orderList.length / itemsPerPage);



    // Calculate the next group's start index

    if (pageGroupStart + visiblePages <= totalPages) {

      this.setState({ pageGroupStart: pageGroupStart + visiblePages });

    }

  };



  // Handle previous page group

  handlePreviousPageGroup = () => {

    const { pageGroupStart, visiblePages } = this.state;



    // Calculate the previous group's start index

    if (pageGroupStart - visiblePages > 0) {

      this.setState({ pageGroupStart: pageGroupStart - visiblePages });

    }

  };



  render() {

    const {

      user,

      orderList,

      searchQuery,

      currentPage,

      itemsPerPage,

      visiblePages,

      pageGroupStart,

    } = this.state;



    // Filter orders based on the search query across multiple fields

    const filteredOrders = orderList.filter((order) => {

      const orderIDMatch = order.number

        .toLowerCase()

        .includes(searchQuery.toLowerCase());

      const dateMatch = (

        <Moment format="DD - MM - YYYY">{order.createdAt}</Moment>

      )

        .toString()

        .toLowerCase()

        .includes(searchQuery.toLowerCase());



      const productMatch = order.orderPaths.some((path) =>

        path.productName.toLowerCase().includes(searchQuery.toLowerCase())

      );



      return orderIDMatch || dateMatch || productMatch;

    });



    const totalOrders = filteredOrders.length;



    // Calculate the number of visible pages based on screen size

    const maxVisiblePages = visiblePages;



    // Calculate the index of the first and last product for the current page

    const indexOfLastProduct = currentPage * itemsPerPage;

    const indexOfFirstProduct = indexOfLastProduct - itemsPerPage;

    const currentProducts = filteredOrders.slice(

      indexOfFirstProduct,

      indexOfLastProduct

    ); // Slice the products based on the current page



    // Calculate total pages

    const totalPages = Math.ceil(orderList.length / itemsPerPage);



    // Determine the page numbers to show

    const pageNumbers = [];

    for (

      let i = pageGroupStart;

      i < Math.min(pageGroupStart + maxVisiblePages, totalPages + 1);

      i++

    ) {

      pageNumbers.push(i);

    }



    return (

      <div className="wrapper">

        <div className="gambo-Breadcrumb">

          <div className="container">

            <div className="row">

              <div className="col-md-12">

                <nav aria-label="breadcrumb">

                  <ol className="breadcrumb">

                    <li className="breadcrumb-item">

                      <a href="/">Home </a>

                    </li>

                    <li className="breadcrumb-item active" aria-current="page">

                      Downloads

                    </li>

                  </ol>

                </nav>

              </div>

            </div>

          </div>

        </div>

        <div className="dashboard-group">

          <div className="container">

            <div className="row">

              <div className="col-lg-12">

                <div className="user-dt">

                  <div className="user-img">

                 <img

    src={user.profilephoto || "/img/avatar/img-5.jpg"}

    alt="Avatar"

    style={{

        width: "120px",

        height: "120px",

        objectFit: "cover",

        borderRadius: "50%"

    }}

    onError={(e) => {

        e.target.src = "/img/avatar/img-5.jpg";

    }}

/>

                    {/* <div className="img-add">

                      <input type="file" id="file" />

                      <label htmlFor="file">

                        <i className="uil uil-camera-plus" />

                      </label>

                    </div> */}

                  </div>

                  <h4>{user.fullName}</h4>

                  <p>+91 {user.phone}</p>

                </div>

              </div>

            </div>

          </div>

        </div>

        <div className="container">

          <div className="row">

            <div className="col-lg-3 col-md-4">

              <div className="left-side-tabs">

                <div className="dashboard-left-links">

                  <a href="/account/view" className="user-item">

                    <i className="uil uil-apps" />

                    Overview

                  </a>

                  <a href="/account/wallet" className="user-item">

                    <i className="uil uil-wallet" />

                    Wallet

                  </a>

                  <a href="/account/profile" className="user-item">

                    <i className="mdi mdi-account-outline" />

                    My profile

                  </a>

                  <a href="/account/order" className="user-item active">

                    <i className="uil uil-box" />

                    Downloads

                  </a>

                  <a href="/account/wishlist" className="user-item">

                    <i className="uil uil-heart" />

                    Shopping Wishlist

                  </a>

                  <a href="/account/address" className="user-item">

                    <i className="uil uil-location-point" />

                    My Address

                  </a>

                  <a className="user-item" onClick={this.handleLogout}>

                    <i className="uil uil-exit" />

                    Logout

                  </a>

                </div>

              </div>

            </div>

            <div className="col-lg-9 col-md-8">

              <div className="dashboard-right">

                <div className="row">

                  <div className="col-md-12">

                    <div className="main-title-tab">

                   
<div className="title-row">
  <h4 className="download-title">
    <i className="uil uil-box"></i>
    My Downloads - ({totalOrders})
  </h4>

  <div
    style={{
      display: "flex",
      gap: "10px",
      flexWrap: "wrap",
      alignItems: "center",
    }}
  >

    <button
      type="button"
      className="refresh-btn"
      onClick={this.refreshOrders}
    >
      <i className="uil uil-refresh"></i> Refresh Orders
    </button>
  </div>
</div>




                      <p className="download-subtext">

                        If you don't find your recent purchases, please refresh

                        your orders.

                      </p>

                    </div>

                  </div>

                  <div className="col-lg-12 col-md-12">

                    <div className="pdpt-bg">

                      <div className="pdpt-title">

                        <h6>Order List</h6>

                        <div className="col-md-10 text-center">

                          <input

                            type="text"

                            className="form-control"

                            placeholder="Search the downloads"

                            value={searchQuery}

                            onChange={this.handleSearch}

                          />

                        </div>

                      </div>

                      <div className="order-body10">

                        <div className="card card-body account-right">

                          <div className="widget">

                            <div className="order-list-tabel-main table-responsive">

                              <table

                                className="datatabel table table-striped table-bordered order-list-tabel"

                                width="100%"

                                cellSpacing="0"

                              >

                                <thead>

                                  <tr>

                                    <th>S.No</th>

                                    <th>Order ID</th>

                                    <th>Total</th>

                                    <th>Product Image</th>

                                    <th>Product Details</th>

                                    <th>JC Nexus</th>

                                  </tr>

                                </thead>

                                <tbody>

                                  {currentProducts.length > 0 ? (

                                    currentProducts.map((row, index) =>

                                      row.orderPaths.length > 0

                                        ? row.orderPaths.map((path, i) => (

                                            <React.Fragment

                                              key={`${index}-${i}`}

                                            >

                                              <tr>

                                                <td

                                                  rowSpan={

                                                    path.variants &&

                                                    path.variants.length > 0

                                                      ? path.variants.length

                                                      : 1

                                                  }

                                                >

                                                  {(currentPage - 1) *

                                                    itemsPerPage +

                                                    index +

                                                    1}

                                                </td>



                                                <td
                                                  rowSpan={
                                                    path.variants && path.variants.length > 0
                                                      ? path.variants.length
                                                      : 1
                                                  }
                                                >
                                                  <div className="order-id-cell">
                                                    <strong>#{row.number}</strong>
                                                    <span className="order-purchase-date">
                                                      <Moment format="DD - MM - YYYY">{row.createdAt}</Moment>
                                                    </span>
                                                  </div>
                                                </td>

                                                <td

                                                  rowSpan={

                                                    path.variants &&

                                                    path.variants.length > 0

                                                      ? path.variants.length

                                                      : 1

                                                  }

                                                >

                                                  ₹{row.grandtotal}

                                                </td>

                                                <td

                                                  rowSpan={

                                                    path.variants &&

                                                    path.variants.length > 0

                                                      ? path.variants.length

                                                      : 1

                                                  }

                                                >

                                                  {path.productPhoto ? (

                                                    <img

                                                      crossOrigin="anonymous"

                                                      src={path.productPhoto}

                                                      alt={path.productName}

                                                      style={{

                                                        width: "150px",

                                                        height: "100px",

                                                        objectFit: "contain",

                                                      }}

                                                    />

                                                  ) : (

                                                    <span>

                                                      No product Image

                                                    </span>

                                                  )}

                                                </td>

                                                <td>

                                                  <strong>Product:</strong>{" "}

                                                  {path.productName}

                                                  <br />

                                                  {path.variants &&

                                                  path.variants.length > 0 ? (

                                                    <>

                                                      <strong>Variant:</strong>{" "}

                                                      {

                                                        path.variants[0]

                                                          .variantName

                                                      }

                                                      <br />

                                                      <button

                                                        type="button"

                                                        onClick={() =>

                                                          this.handleDownload(

                                                            path.variants[0]

                                                              .variantPath

                                                          )

                                                        }

                                                        className="btn-link"

                                                        style={{

                                                          background: "none",

                                                          border: "none",

                                                          padding: 0,

                                                          color: "#007bff",

                                                          textDecoration:

                                                            "underline",

                                                          cursor: "pointer",

                                                        }}

                                                      >

                                                        Download

                                                      </button>

                                                      <br />

                                                    </>

                                                  ) : (

                                                    <span>

                                                      No variant available

                                                    </span>

                                                  )}

                                                </td>

                                                <td className="jc-canvas-cell">
                                                  <button
                                                    type="button"
                                                    className="jc-canvas-btn"
                                                    onClick={() => this.handleJCCanvas(path.variants && path.variants[0])}
                                                    disabled={!path.variants || !path.variants[0] || !path.variants[0].variantPath}
                                                  >
                                                    <i className="uil uil-palette" />
                                                    <span>JC Nexus</span>
                                                  </button>
                                                </td>

                                              </tr>

                                              {path.variants &&

                                                path.variants

                                                  .slice(1)

                                                  .map((variant, vIndex) => (

                                                    <tr

                                                      key={`${index}-${i}-${vIndex}`}

                                                    >

                                                      <td>

                                                        <strong>

                                                          Variant:

                                                        </strong>{" "}

                                                        {variant.variantName}

                                                        <br />

                                                        <button

                                                          type="button"

                                                          onClick={() =>

                                                            this.handleDownload(

                                                              variant.variantPath

                                                            )

                                                          }

                                                          className="btn-link"

                                                          style={{

                                                            background: "none",

                                                            border: "none",

                                                            padding: 0,

                                                            color: "#007bff",

                                                            textDecoration:

                                                              "underline",

                                                            cursor: "pointer",

                                                          }}

                                                        >

                                                          Download

                                                        </button>

                                                        <br />

                                                      </td>

                                                      <td className="jc-canvas-cell">
                                                        <button
                                                          type="button"
                                                          className="jc-canvas-btn"
                                                          onClick={() => this.handleJCCanvas(variant)}
                                                          disabled={!variant.variantPath}
                                                        >
                                                          <i className="uil uil-palette" />
                                                          <span>JC Nexus</span>
                                                        </button>
                                                      </td>

                                                    </tr>

                                                  ))}

                                            </React.Fragment>

                                          ))

                                        : null

                                    )

                                  ) : (

                                    <tr>

                                      <td colSpan="6" className="text-center">

                                        No orders found.

                                      </td>

                                    </tr>

                                  )}

                                </tbody>

                              </table>

                            </div>

                          </div>

                        </div>

                      </div>

                    </div>

                    {/* Pagination Controls */}

                    <div className="pagination-controls">

                      <button

                        className="arrow-button"

                        onClick={this.handlePreviousPageGroup}

                        disabled={pageGroupStart === 1}

                      >

                        &lt;

                      </button>

                      {pageNumbers.map((number) => (

                        <button

                          key={number}

                          className={`page-button ${

                            currentPage === number ? "active" : ""

                          }`}

                          onClick={() => this.handlePageChange(number)}

                        >

                          {number}

                        </button>

                      ))}

                      <button

                        className="arrow-button"

                        onClick={this.handleNextPageGroup}

                        disabled={pageGroupStart + maxVisiblePages > totalPages}

                      >

                        &gt;

                      </button>

                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    );

  }

}

export default withRouter(List);
